module.exports = __webpack_public_path__ + "static/media/off-boarding.cbe7edee.png";